// removed by extract-text-webpack-plugin
module.exports = {"component":"_2kzru3uzvam8dbqpayyft7d965v6epv9p6yjdjrs9vh725uucugpugwd8xh1dwnfgdfqyzpjpwup7ksxje3tbrfgtuzcp6ubxptrj23-styles-module-component"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Body/styles.module.sass
// module id = 579
// module chunks = 0